import defaults from 'lodash/defaults';
import {IonicModal} from '../../react-modals/IonicModal';
import {ReactReduxModal} from '../../react-redux-modals';
import {ReactReduxModalHOC} from '../../react-redux-modals/components/ReactReduxModalHOC';
import {buildActions} from './buildActions';
import {UpdateModalEpics} from './buildEpics';
import {buildReducer} from './buildReducer';


/**
 * @param {UpdateModalOptions} o
 * @constructor
 */
export function UpdateModal(o) {
  /** @type {UpdateModalOptions} **/
  const options = {};
  defaults(options, o, {
    showMessageTime: 5000,
    serializeBody: JSON.stringify.bind(JSON),
    getHeaders: () => ({}),
    requestOptions: {},
    requestMethod: 'POST',
    hideOnError: false,
  });

  const reactReduxModalOptions = {
    prefix: options.prefix,
    getState: options.getState,
    modalOptions: options.modalOptions,
    logger: options.logger,
  };

  const reactReduxModal = new ReactReduxModal(reactReduxModalOptions);

  this.options = options;
  this.actions = buildActions(reactReduxModal, options);
  this.reducers = buildReducer(reactReduxModal, this.actions, options);
  this.epics = new UpdateModalEpics(this.actions, options);
  this.epics.addEpics(reactReduxModal.epics.epics);

  const modalConfig = {
    actions: this.actions,
    getState: this.options.getState,
    logger: this.options.logger,
  };

  reactReduxModalOptions.modalComponent = this.options.modalComponent = this.modalComponent = ReactReduxModalHOC(
    this.options.modalComponent,
    modalConfig,
    IonicModal,
  );
}
/**
 * @typedef {Object} UpdateModalOptions
 * @property {String} prefix
 * @property {Function} getState
 * @property {String|UpdateModalOptions~requestUrl} requestUrl
 * @property {UpdateModalOptions~serializeBody} [serializeBody]
 * @property {UpdateModalOptions~getHeaders} [getHeaders]
 * @property {Object} [requestOptions={}]
 * @property {String} [requestMethod=POST]
 * @property {Number} [showMessageTime=5000]
 * @property {String} [hideOnError=false]
 *
 * @property modalOptions
 * @property modalComponent
 * @property {Logger} logger
 */

/**
 * @callback UpdateModalOptions~requestUrl
 * @param {ReduxAction} action
 * @return {String}
 */

/**
 * @callback UpdateModalOptions~serializeBody
 * @param {Object} body
 * @return {String}
 */

/**
 * @callback UpdateModalOptions~getHeaders
 * @param {ReduxAction} action
 * @param {Object} rootState
 * @return {Object<String, String>}
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux/update-modal/index.js